module.exports = __webpack_public_path__ + "img/25-1500-nav.9015137a.png";